import type { PropsWithChildren } from 'react';
import React from 'react';

import Typography from 'src/components/ui/Typography';
import { styledComponent, styledTag } from 'src/utils/styled';

const HeaderWrapper = styledTag('section')`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    height: 400px;
    background-image: url('${process.env.NEXT_PUBLIC_SITE_URL}/assets/images/legal/header.png');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    color: white;
`;

const LogoWrapper = styledTag('a')`
    position: absolute;
    top: 1rem;
    left: 1rem;
    width: 160px;
`;

const StyledLogo = styledTag('img')`
    width: 100%;
`;

const StyledTitle = styledComponent(Typography)`
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 1rem;
    color: white;
`;

export const LegalHeader: React.FC<PropsWithChildren> = ({ children }) => (
    <HeaderWrapper>
        <LogoWrapper href="/">
            <StyledLogo
                src={`${process.env.NEXT_PUBLIC_SITE_URL}/assets/images/legal/logo-horizontal.png`}
                alt="Logo"
            />
        </LogoWrapper>
        <StyledTitle variant="h1">{children}</StyledTitle>
    </HeaderWrapper>
);
